import { NgModule } from '@angular/core';
import { CommonModule } from '@nano/common';
import { AlertModule } from '@nano/common/alert';
import { CollapseModule } from '@nano/common/collapse';
import { FileUploadModule } from '@nano/common/file';
import { FinanceModule, InstitutionAutocompleteModule } from '@nano/common/finance';
import { IconWithPopoverModule } from '@nano/common/icon-with-popover';
import { TfaModule } from '@nano/core/tfa';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzNoAnimationModule } from 'ng-zorro-antd/core/animation';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

import { AccountNumberInputComponent } from './account-number-input/account-number-input.component';
import { BankTransferComponent } from './bank-transfer.component';
import { PaymentIdentificationComponent } from './payment-identification/payment-identification.component';
import { PaymentAddressComponent } from './payment-address/payment-address.component';
import { BeneficiaryNameInputComponent } from './beneficiary-name-input/beneficiary-name-input.component';
import { BeneficiaryAccountNumberInputComponent } from './beneficiary-account-number-input/beneficiary-account-number-input.component';
import { BeneficiaryBankDetailsComponent } from './beneficiary-bank-details/beneficiary-bank-details.component';
import { PaymentAmountComponent } from './payment-amount/payment-amount.component';
import { InstructionIdentificationComponent } from './instruction-identification/instruction-identification.component';
import { ServiceChargeDetailsComponent } from './service-charge-details/service-charge-details.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { ScheduledPaymentComponent } from './scheduled-payment/scheduled-payment.component';
import { CorrespondentBankInformationComponent } from './correspondent-bank-information/correspondent-bank-information.component';
import { AccountSelectModule } from '@nano/account/account-select';
import { PaymentGatewayInfoComponent } from './payment-gateway-info/payment-gateway-info.component';
import { IntlTelInputModule } from '@nano/common/phone';

const nanoModules = [
  CommonModule,
  AlertModule,
  CollapseModule,
  FileUploadModule,
  FinanceModule,
  IconWithPopoverModule,
  InstitutionAutocompleteModule,
  TfaModule,
  AccountSelectModule,
  IntlTelInputModule
];
const nzModules = [NzAutocompleteModule, NzDatePickerModule, NzNoAnimationModule];

@NgModule({
  imports: [nanoModules, nzModules],
  declarations: [
    AccountNumberInputComponent,
    PaymentIdentificationComponent,
    BankTransferComponent,
    PaymentAddressComponent,
    BeneficiaryNameInputComponent,
    BeneficiaryAccountNumberInputComponent,
    BeneficiaryBankDetailsComponent,
    PaymentAmountComponent,
    InstructionIdentificationComponent,
    ServiceChargeDetailsComponent,
    PaymentDetailsComponent,
    ScheduledPaymentComponent,
    CorrespondentBankInformationComponent,
    PaymentGatewayInfoComponent
  ],
  exports: [BankTransferComponent, AccountNumberInputComponent]
})
export class BankTransferModule {}
